export enum ManifestStatusType {
  Future = "F",
  Active = "A",
  Inactive = "I"
}

export type manifestAttributes = {
  manifestStatus?: ManifestStatusType;
};
